// React imports
import React, { useState, useEffect } from "react"

// package imports
import PropTypes from "prop-types"
import { Button as UiButton, CustomCheckbox } from "components"
import { Button, Card, Modal } from "react-bootstrap"
import moment from "moment"
import { observer } from "mobx-react"
import { toJS } from "mobx"

// Project imports

import FamilyDetailsStore from "modules/family-details-form/store/FamilyDetailsStore"
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import AddInsuredMemberCard from "./add-Insured-modal-form"
import {
  FamilyIcon,
  CheckSecondaryImg,
  CloseIconBlack,
  PlusIconFilledIcon,
} from "constants/Images"
import AuthStore from "modules/login/store/AuthStore"
import AddInsuredFormController from "./add-Insured-modal-form/controller"
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum"
import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum"
import isObjectEmpty from "utils/isObjectEmpty"
import NeedTypeEnum from "constants/NeedTypeEnum"
import changeProposerApiCall from "modules/optimization/utils/change-proposer/changeProposerApiCall"


// css imports
import "./add-insured.css"
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, INDIVIDUAL, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../constants/Constants"
import StorageKeys from "constants/StorageKeys"
import ProductPackageId from "constants/ProductPackageId"

const AddInsuredModal = (props) => {
  const [formController, setFormController] = useState(undefined);

  let {
    show,
    onAddMember,
    onHide,
    eligibleLaList,
    proposerList
  } = props

  useEffect(() => {
    let controller = new AddInsuredFormController()
    let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)


    let familyMemberData = OptimizationStore.fetchFamilyMemberListForLifeAssured()

    controller.setDefaults(journeyId, familyMemberData)
    setFormController(controller)

  }, [show, eligibleLaList, proposerList])


  useEffect(() => {
    let memberObjList = []
    let memberArray = formController?.$("members").get()
    for (const key in memberArray) {
      if (memberArray[key]?.value?.age > 18) {
        memberObjList.push(memberArray[key])
      }
    }

    memberObjList = memberObjList.map((item) => item.value)


    if (memberObjList.length === 1 && OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.CHANGE_PROPOSER) {

      let name = memberObjList[0].name;
      if (!isObjectEmpty(toJS(OptimizationStore.selfFamilyMemberDetail))) {

        if ((JSON.stringify(memberObjList[0])) !== (JSON.stringify(toJS(OptimizationStore.selfFamilyMemberDetail)))) {
          formController.$("members").$(name).$("isSelected").value = true
        }
      }
      else {
        formController.$("members").$(name).$("isSelected").value = false
      }
    } else {

      let initialFamilyMemberList = toJS(OptimizationStore.familyMemberList)
      let finalFamilyMemberList = memberObjList.map((eachMember) => eachMember.name)
      let listOfNewFamilyMemberAdded = finalFamilyMemberList.filter(eachMember => !initialFamilyMemberList.includes(eachMember))
      console.log('listOfNewFamilyMemberAdded', listOfNewFamilyMemberAdded);
      let firstNewlyAddedItem

      if (listOfNewFamilyMemberAdded.length === 2 &&
        listOfNewFamilyMemberAdded.includes('GRAND_FATHER') &&
        listOfNewFamilyMemberAdded[1].startsWith('ADULT')) {
        firstNewlyAddedItem = listOfNewFamilyMemberAdded[1]
      } else if (listOfNewFamilyMemberAdded.length === 2 &&
        listOfNewFamilyMemberAdded.includes('GRAND_MOTHER') &&
        listOfNewFamilyMemberAdded[0].startsWith('ADULT')) {
        firstNewlyAddedItem = listOfNewFamilyMemberAdded[1]
      }
      else {
        firstNewlyAddedItem = listOfNewFamilyMemberAdded[0]
      }

      for (let item of memberObjList) {

        if (item.name === "SELF") {

          let currentSelfObject = { ...item }
          let selfObjectFromFamilyDetailsScreen = { ...toJS(OptimizationStore.selfFamilyMemberDetail) }

          delete currentSelfObject.isSelected
          delete selfObjectFromFamilyDetailsScreen.isSelected

          if (!isObjectEmpty(selfObjectFromFamilyDetailsScreen) && (JSON.stringify(currentSelfObject)) !== (JSON.stringify(selfObjectFromFamilyDetailsScreen)) && toJS(OptimizationStore.currentLaType) === "SELF") {
            formController.$("members").$(item.name).$("isSelected").value = true
            break;
          }
          else {
            formController.$("members").$(item.name).$("isSelected").value = false
          }
        }
        const currentLa = toJS(OptimizationStore.currentLaType)
        let listOfMembers = formController.$("members").get()

        if (currentLa && listOfMembers.hasOwnProperty(currentLa) && Object.keys(listOfMembers).length > 1) {
          formController.$("members").$(currentLa).$("isSelected").value = false

          let memberList = Object.keys(listOfMembers)
          memberList.splice(memberList.indexOf(currentLa), 1)
          formController.$("members").$(memberList[0]).$("isSelected").value = true
        }
        else if (item.name === firstNewlyAddedItem) {
          OptimizationStore.setFirstNewlyAddedItem(firstNewlyAddedItem)
          formController.$("members").$(item.name).$("isSelected").value = true
        } else {
          formController.$("members").$(item.name).$("isSelected").value = false
        }
        if (!firstNewlyAddedItem) {
          const isSelectedList = Object.values(listOfMembers).map(obj => obj.value.isSelected)
          if (isSelectedList.every(el => el === false)) {
            if (AuthStore.journeyTypeName === INDIVIDUAL || AuthStore.journeyTypeName === MWP_ACT) {
              formController.$("members").$("SELF").$("isSelected").value = true
            } else if (AuthStore.journeyTypeName === HUF) {
              formController.$("members").$("FAMILY_MEMBER1").$("isSelected").value = true
            } else if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_A || AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === PARTNERSHIP || AuthStore.journeyTypeName === KEYMAN) {
              formController.$("members").$("EMPLOYEE1").$("isSelected").value = true
            }
          }
        }
      }
    }

  }, [formController])



  if (formController === undefined) return null

  let memberObjList = []
  let memberObjList2 = []
  let memberArray = formController.$("members").get()
  let secMemberArray = formController.$("secondary_members").get()
  for (const key in memberArray) {
    memberObjList.push(memberArray[key])
  }
  for (const key in secMemberArray) {
    memberObjList2.push(secMemberArray[key])
  }

  const currentLa = toJS(OptimizationStore.currentLaType)
  let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false


  if (OptimizationStore.familyMemberModalType !== FamilyMemberModalTypeEnum.CHANGE_PROPOSER && !pasaCampaignProduct) {
    memberObjList = memberObjList.map((item) => {
      if (item.value.name === currentLa && memberObjList.length > 1) {
        item.value.disabled = true
      } else {
        item.value.disabled = false
      }

      return item.value
    })
    if (OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_INSURED || OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_NEED) {
      let selectedPrimaryLA = memberObjList?.find((item) => item?.isSelected)
      console.log("selectedPrimaryLA ", selectedPrimaryLA)
      memberObjList2 = memberObjList2.map((item) => {
        if (item.value.id === selectedPrimaryLA?.id && memberObjList.length > 0) {
          item.value.disabled = true
          item.value.isSelected = false
        } else {
          item.value.disabled = false
        }

        if (selectedPrimaryLA?.age > 50) {
          item.value.disabled = true
          item.value.isSelected = false
          OptimizationStore.setSecondaryLASelectdForAddAssured(null)
        }
        if (item?.value?.name.startsWith(FamilyMemberTypeEnum.GRAND_CHILD) && (selectedPrimaryLA?.name === FamilyMemberTypeEnum.GRAND_FATHER || selectedPrimaryLA?.name === FamilyMemberTypeEnum.GRAND_MOTHER)) {
          item.value.disabled = true
          item.value.isSelected = false
        }

        return item.value
      })
    }
  } else if (OptimizationStore.familyMemberModalType !== FamilyMemberModalTypeEnum.CHANGE_PROPOSER && pasaCampaignProduct) {
    memberObjList = memberObjList.map((item) => {
      let laType = OptimizationStore.pasaLifeAssuredType
      if (item.label === laType) {
        item.value.isSelected = true
      } else {
        item.value.isSelected = false
      }
      item.value.disabled = true
      return item.value
    })
    memberObjList2 = memberObjList2.map((item) => {
      let laType = OptimizationStore.pasaLifeAssuredType
      if (item.label === laType) {
        item.value.isSelected = true
      } else {
        item.value.isSelected = false
      }
      item.value.disabled = true
      return item.value
    })

  } else {
    memberObjList = memberObjList.map((item) => {
      item.value.disabled = false
      return item.value
    })
  }


  console.log("memberObjList ", OptimizationStore.familyMemberModalType)

  //  ! for switching the modal Type

  let modalType

  switch (OptimizationStore.familyMemberModalType) {

    case FamilyMemberModalTypeEnum.CHANGE_LA:
      modalType = "Change Life Assured"
      break;

    case FamilyMemberModalTypeEnum.CHANGE_SECONDARY_LA:
      modalType = "Change Secondary LA"
      break

    case FamilyMemberModalTypeEnum.ADD_SECONDARY_LA:
      modalType = "Add Secondary LA"
      break

    case FamilyMemberModalTypeEnum.CHANGE_PROPOSER:
      modalType = "Change Proposer"
      break;

    case FamilyMemberModalTypeEnum.ADD_INSURED:
    default:
      modalType = "Add Life Assured"
      break;
  }

  let showChangeLaValidation = memberObjList.length <= 1 && OptimizationStore.familyMemberModalType !== FamilyMemberModalTypeEnum.ADD_NEED

  const addIdToOptimisationStore = (memberObjectLength, formController, onHide) => {

    if (OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_INSURED && (OptimizationStore.selectedNeed !== NeedTypeEnum.PROTECTION_FOR_MY_FAMILY && OptimizationStore.selectedNeed !== NeedTypeEnum.PROTECTION_FOR_MY_HEALTH)) {
      showChangeLaValidation = false
    }
    if (OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_SECONDARY_LA) {
      showChangeLaValidation = false
    }
    if (showChangeLaValidation) return

    formController.validate({ showErrors: true })
      .then(({ isValid }) => {
        if (isValid) {
          const formFieldValuesArray = formController.get().members.value
          for (const key in formFieldValuesArray) {
            if (formFieldValuesArray[key].isSelected === true) {
              const id = formFieldValuesArray[key].id
              OptimizationStore.setSelectedMemberId(id)
            }
          }
          console.log(OptimizationStore.familyMemberModalType)
          switch (OptimizationStore.familyMemberModalType) {
            case FamilyMemberModalTypeEnum.CHANGE_LA:
              // props.changeLA()
              // OptimizationStore.changeLA()
              break;

            case FamilyMemberModalTypeEnum.CHANGE_PROPOSER:
              changeProposerApiCall()
          }

          onHide()
        }
      });
  }

  const addEditButtonDisabled = () => {
    if ((OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_INSURED || OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_NEED)) {
      return sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false
    } else {
      return false
    }
  }

  //  ! for modal CTA button
  const modalCtaBtn = OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.CHANGE_LA ||
    OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.CHANGE_SECONDARY_LA ||
    OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.CHANGE_PROPOSER ?
    "Change" :
    "Add"


  const ctaMessage = (noOfMember, modalType) => {

    if (noOfMember.length <= 1) {

      switch (modalType) {
        case FamilyMemberModalTypeEnum.CHANGE_PROPOSER:
          return <p className="font-weight-medium text-danger font-size-12">Please add a new family member to change the current Proposer.</p>


        case FamilyMemberModalTypeEnum.ADD_INSURED:
          if (OptimizationStore.selectedNeed === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY || OptimizationStore.selectedNeed === NeedTypeEnum.PROTECTION_FOR_MY_HEALTH) {
            return <p className="font-weight-medium text-danger font-size-12">Please add a new family member to add a new Life Assured</p>
          } else {
            return null
          }


        case FamilyMemberModalTypeEnum.CHANGE_LA:
        case FamilyMemberModalTypeEnum.CHANGE_SECONDARY_LA:
        case FamilyMemberModalTypeEnum.ADD_SECONDARY_LA:
          return <p className="font-weight-medium text-danger font-size-12">Please add a new family member to change the current Life Assured.</p>

        default:
          return null
      }


    }

  }


  let primaryLaList = [];
  let secondaryLaList = []

  memberObjList.forEach((item) => {
    if (item.age >= 18) {
      primaryLaList.push(item)
    }
  })

  let packageId = "";
    if (Array.isArray(OptimizationStore.selectedNeedCardData.BI)) {
      let riskProductData = OptimizationStore.selectedNeedCardData.BI.filter(
        (item) => item.risk == OptimizationStore.selectedNeedCardData.selectedRisk
      )[0];
      packageId = riskProductData.package_id;
    }
    console.log("PACKAGE ID ", packageId)
  memberObjList2.forEach((item) => {
    if(packageId === ProductPackageId.FLEXI_GOAL_SECURE && (OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.CHANGE_SECONDARY_LA || FamilyMemberModalTypeEnum.ADD_SECONDARY_LA)) {
      secondaryLaList.push(item)
    } else if (item.age <= 45) {
      secondaryLaList.push(item)
    }
  })

  console.log("setSelectedNeed", memberObjList, memberObjList2)
  // const toggleButton = () => {
  //   if(memberObjList.length > 0){
  //     console.log('memberObjList',memberObjList);
  //     const selectedFamilyMember = memberObjList?.find(member => member.isSelected)
  //     const currentLa = toJS(OptimizationStore.currentLaType)
  //     return currentLa === selectedFamilyMember?.family_member_type
  //   }else{
  //     return false
  //   }
  // }

  return (
    <div>
      <Modal
        className="add-insured-modal left-bottom-swipe-modal"
        show={show}
        onHide={onHide}
        keyboard={false}
      >
        <Modal.Header
          closeButton={false}
          className="pb-0 mx-md-2 border-bottom-0"
        >
          <Modal.Title className="text-primary-title-label-color">
            <img
              src={FamilyIcon}
              alt="family-icon"
              className="add-insured-member-card-modal-top-img"
            />
            <span className="title font-size-18">{modalType}</span>
          </Modal.Title>

          <div className=" mt-2 pt-1">
            <UiButton
              variant=""
              className="d-inline-flex align-items-center p-0"
              type="submit"
              // disabled={toggleButton()}
              onClick={() => {
                addIdToOptimisationStore(memberObjList.length, formController, onHide, modalCtaBtn)
                OptimizationStore.setCurrentLaType('');
              }}
            >
              <img
                src={CheckSecondaryImg}
                alt="checked-icon"
                className="fm-modal-btn-icon font-weight-bold"
              />
              <p className="mb-0 font-size-16 font-size-md-12 font-weight-bold text-secondary pl-1">
                {modalCtaBtn}
              </p>
            </UiButton>


            <UiButton
              variant=""
              className="d-inline-flex align-items-center p-0 ml-2"
              onClick={() => {
                OptimizationStore.resetSelectedNeedAndMemberId()
                onHide()
                OptimizationStore.setCurrentLaType('');
              }}
            >
              <img
                src={CloseIconBlack}
                alt="close-icon"
                className="fm-modal-btn-icon font-weight-bold"
              />
              <p className="mb-0 font-size-16 font-size-md-12 font-weight-bold pl-1">
                Cancel
              </p>
            </UiButton>
          </div>
        </Modal.Header>

        <Modal.Body className="">

          {(OptimizationStore.familyMemberModalType != FamilyMemberModalTypeEnum.ADD_INSURED && OptimizationStore.familyMemberModalType != FamilyMemberModalTypeEnum.ADD_NEED) ?
            <>

              {memberObjList.map((item) => {
                let {
                  id,
                  name,
                  disabled,
                  salutation,
                  first_name: firstName,
                  middle_name: middleName,
                  last_name: lastName,
                  gender,
                  age,
                  family_member_type: memberType,
                  isSelected,
                } = item
                return (
                  <AddInsuredMemberCard
                    key={id}
                    name={name}
                    disabled={disabled}
                    isSelected={isSelected}
                    memberType={memberType}
                    salutation={salutation}
                    firstName={firstName}
                    gender={gender}
                    middleName={middleName}
                    lastName={lastName}
                    age={age}
                    formController={formController}
                    isAddAssuredSelect={false}
                    toDeselectMember={true}
                  />
                )
              })}
            </>
            :
            <>
              {((OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_INSURED || OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_NEED) && OptimizationStore.setNeed != "Protection for my Family") ?
                <>
                  <div className="pl-2 font-weight-medium">
                    <p>Select Primary Life Assured</p>
                  </div>
                  {
                    primaryLaList.map((item) => {
                      let {
                        id,
                        name,
                        disabled,
                        salutation,
                        first_name: firstName,
                        middle_name: middleName,
                        last_name: lastName,
                        gender,
                        age,
                        family_member_type: memberType,
                        isSelected,
                      } = item
                      return (
                        <AddInsuredMemberCard
                          key={id}
                          name={name}
                          disabled={disabled}
                          isSelected={isSelected}
                          memberType={memberType}
                          salutation={salutation}
                          firstName={firstName}
                          gender={gender}
                          middleName={middleName}
                          lastName={lastName}
                          age={age}
                          formController={formController}
                          isAddAssuredSelect={false}
                          toDeselectMember={true}
                        />
                      )
                    })
                  }

                  <div className="pl-2 font-weight-medium">
                    <p>Select Secondary Life Assured</p>
                  </div>
                  {secondaryLaList.map((item) => {
                    let {
                      id,
                      name,
                      disabled,
                      salutation,
                      first_name: firstName,
                      middle_name: middleName,
                      last_name: lastName,
                      gender,
                      age,
                      family_member_type: memberType,
                      isSelected,
                    } = item
                    return (
                      <AddInsuredMemberCard
                        key={id}
                        name={name}
                        disabled={disabled}
                        isSelected={isSelected}
                        memberType={memberType}
                        salutation={salutation}
                        firstName={firstName}
                        gender={gender}
                        middleName={middleName}
                        lastName={lastName}
                        age={age}
                        formController={formController}
                        isAddAssuredSelect={true}
                        toDeselectMember={false}
                      />
                    )
                  })}

                </>
                :
                <>
                  {memberObjList.map((item) => {
                    let {
                      id,
                      name,
                      disabled,
                      salutation,
                      first_name: firstName,
                      middle_name: middleName,
                      last_name: lastName,
                      gender,
                      age,
                      family_member_type: memberType,
                      isSelected,
                    } = item
                    return (
                      <AddInsuredMemberCard
                        key={id}
                        name={name}
                        disabled={disabled}
                        isSelected={isSelected}
                        memberType={memberType}
                        salutation={salutation}
                        firstName={firstName}
                        gender={gender}
                        middleName={middleName}
                        lastName={lastName}
                        age={age}
                        formController={formController}
                        isAddAssuredSelect={false}
                        toDeselectMember={true}
                      />
                    )
                  })}
                </>
              }
            </>
          }



          {ctaMessage(memberObjList, OptimizationStore.familyMemberModalType)}

          <hr className="underline" />

          <Button
            variant=""
            onClick={() => onAddMember(memberObjList)}
            role="button"
            className="text-scondary w-100 text-right font-weight-light add-Buttton"
            disabled={addEditButtonDisabled()}
          >
            <img
              className="mr-2 plusIconStyle"
              src={PlusIconFilledIcon}
              alt="plus-icon"
            />
            {(AuthStore.journeyTypeName === HUF || AuthStore.journeyTypeName === MWP_ACT || AuthStore.journeyTypeName === INDIVIDUAL) ? 'Add/Edit Family Member Details' : 'Add/Edit Employee Details'}
          </Button>
        </Modal.Body>
      </Modal>
    </div>

  )
}

AddInsuredModal.defaultsProps = {
  onHide: () => { },
}

AddInsuredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onAddMember: PropTypes.func.isRequired,
  onAddInsured: PropTypes.func.isRequired,
  onAddInsured: PropTypes.func.isRequired,
}


export default observer(AddInsuredModal)